// CSS
import '../sass/pages/home.scss'

// === WP ALPHA ASSETS
import '@nematis/wp-alpha/assets/js/home'

// === HOME modules (fidélité maquette)
import {
  initHomeDecor
} from './modules/home/decor'

const boot = () => {
  initHomeDecor()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}
